import { render, staticRenderFns } from "./AuditoriasDados.vue?vue&type=template&id=034a56da&scoped=true"
import script from "./AuditoriasDados.vue?vue&type=script&lang=js"
export * from "./AuditoriasDados.vue?vue&type=script&lang=js"
import style0 from "./AuditoriasDados.vue?vue&type=style&index=0&id=034a56da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a56da",
  null
  
)

export default component.exports